import { CacheStore } from '@nestjs/cache-manager';
import { CacheStoreSetOptions } from '@nestjs/cache-manager/dist/interfaces/cache-manager.interface';
import { Model, Schema } from 'mongoose';

import { MongoConnection } from '../connections';

export class MongoStore implements CacheStore {
  private model!: Model<any>;
  private readonly options = { collection: 'cache-manager', versionKey: false };

  constructor() {
    void this.initialize();
  }

  public async del(key: string): Promise<void> {
    await this.model.deleteOne({ _id: key });
  }

  public async get<T>(key: string): Promise<T | undefined> {
    const document = (await this.model.findById(key).lean()) as any;
    if (!document?.expire || document.expire >= new Date()) return document?.value;
    await this.del(key);
    return;
  }

  public async set<T>(key: string, value: T, options?: CacheStoreSetOptions<T> | number): Promise<void> {
    const document = { value } as any;
    if (typeof options === 'number') options = { ttl: options };
    if (options?.ttl) document.expire = new Date(Date.now() + (options.ttl as number));
    await this.model.updateOne({ _id: key }, document, { upsert: true });
  }

  private async initialize(): Promise<void> {
    const schema = new Schema({ _id: String, value: Schema.Types.Mixed, expire: Date }, this.options);
    schema.index({ expire: 1 }, { expireAfterSeconds: 0 });
    const connection = await MongoConnection.Instance;
    this.model = connection.model('CacheManager', schema);
  }
}
